import { render } from "./tcHouseVipManage.vue?vue&type=template&id=30a75033"
import script from "./tcHouseVipManage.vue?vue&type=script&lang=js"
export * from "./tcHouseVipManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__